import { updateState } from '@fil-global/eiswagen';
import { combineReducers } from 'redux';
import {
  SET_LOCALE,
  FETCH_LABEL,
  FETCH_LABEL_SUCCESS,
  FETCH_LABEL_FAILURE,
  PAGE_TRANSITION,
  DEVICE_RESIZE_ACTION,
  SECURE_ROUTE_FLAG_ACTION,
  SET_LANGUAGE,
  SET_REGION,
} from './constants';

const globalData = (
  state = {
    isAppSecure: false,
    labels: { login: {}, otp: {} },
    language: 'en',
    region: 'FIL',
  },
  action
) => {
  switch (action.type) {
    case SET_LOCALE:
      return updateState(state, { locale: action.data });
    case FETCH_LABEL:
      return updateState(state, {
        isFetching: true,
        label: { login: {}, otp: {} },
      });
    case FETCH_LABEL_SUCCESS:
      return updateState(state, { labels: action.labels, isFetching: false });
    case FETCH_LABEL_FAILURE:
      return updateState(state, { isFetching: false, isError: true });
    case PAGE_TRANSITION:
      return updateState(state, { currentPage: action.page });
    case DEVICE_RESIZE_ACTION:
      return updateState(state, { deviceType: action.data });
    case SECURE_ROUTE_FLAG_ACTION:
      return updateState(state, { isAppSecure: action.data });
    case SET_LANGUAGE:
      return updateState(state, { language: action.data });
    case SET_REGION:
      return updateState(state, { region: action.data });
    default:
      return state;
  }
};

export default combineReducers({ globalData });
